<!-- 大屏编排对阵 -->
<template>
   <div class="content">
    <div class="title">        
        <div>{{titlePub}}</div>
        <div class="round-title">第{{round}}轮编排</div>
    </div>    
    <div v-if="isReady">
        <div class="matches-container">
            <el-card 
                v-for="item in roundsData" 
                :key="item.id"
                class="match-card"
                shadow="hover"
            >
                <div class="table-number">{{ item.deskNo }}号桌</div>
                <div class="team team-east">
                    <span class="team-position">东西</span>
                    <div class="team-info">
                        <span class="team-code">{{item.usernameWE}}</span>
                        <span class="team-name">{{ item.companyWE }}</span>
                    </div>
                    <span class="team-role">{{ item.teamTypeWE }}</span>
                </div>
                <div class="team team-south">
                    <span class="team-position">南北</span>
                    <div class="team-info">
                        <span class="team-code">{{ item.usernameSN}}</span>
                        <span class="team-name">{{ item.companySN}}</span>
                    </div>
                    <span class="team-role">{{ item.teamTypeSN}}</span>
                </div>
            </el-card>
        </div>
    </div>
   </div>
</template>
<script>
export default {
    data() {
        return {
            titlePub: '',
            dataList: [],
            roundsData: [],
            firstTableData: [],
            secondTableData: [],
            thirdTableData: [],
            tableData: [],
            isShow: false,
            isReady: false,
            round: 1
        }
    },
    created() {        
        this.pubId = this.$route.query.id
        this.pubType = this.$route.query.type
        this.getTitle()
    },
    mounted() {
        document.addEventListener('click', this.toggleFullScreen);
    },
    computed:{
        
    },
    methods: {
        tableRowClassName({row, rowIndex}){
            // 一桌一种颜色
            if(row.deskNo % 2){
                return 'white-row'
            }else{
                return  'green-row'
            }
        },
          // 赛事编排对阵查询
        initData(){
            let params = {
                opcode: this.$code.PubArrange,
                i_serial_mark: this.pubId,
                i_round: this.round,
            }
            this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {                    
                    let result = res.Data.DataTable  
                    this.isReady = true                 
                    if(result.length > 0){ 
                        let arr  = result.map(item=>{
                            let username = `${item['选手名称']}/${item['搭档名称']}`
                            return{
                                deskNo: item['桌号'],
                                id: item['选手编号'],
                                username: username,
                                phone: item['选手手机号'],
                                company: item['协会（俱乐部）'],
                                userId: item['选手账号'],
                                seat: item['座位'],
                                status: item['状态'],
                                matchStatus: item['参赛状态'],
                                teamType: item['主客队']
                            }
                        }) 
                        let newArr = this.selectDeskNo(arr)
                        console.log(newArr)
                        this.roundsData = newArr
                    }else{
                        // this.refreshData = []
                    }
                }
            })
        },
        selectDeskNo(arr){
            let result = []
            arr.forEach(item => {
                if(!result.some(i => i.deskNo === item.deskNo)){
                    let newArr = arr.filter(user => user.deskNo === item.deskNo)
                    let seatWE = (newArr.filter(i =>  i.seat.includes('东')))[0].seat
                    let seatSN = (newArr.filter(i =>  i.seat.includes('北')))[0].seat
                    let usernameWE = (newArr.filter(i =>  i.seat.includes('东')))[0].username 
                    let usernameSN = (newArr.filter(i =>  i.seat.includes('北')))[0].username  

                    let teamTypeWE = (newArr.filter(i =>  i.seat.includes('东')))[0].teamType
                    let teamTypeSN = (newArr.filter(i =>  i.seat.includes('北')))[0].teamType
                    
                    let companyA = (newArr.filter(i =>  i.seat.includes('东')))[0].company
                    let companyB = (newArr.filter(i =>  i.seat.includes('北')))[0].company
                    result.push({
                        deskNo: item.deskNo,
                        seatWE: seatWE,
                        seatSN: seatSN,
                        teamTypeWE: teamTypeWE,
                        teamTypeSN: teamTypeSN,
                        usernameWE: usernameWE,
                        usernameSN: usernameSN, 
                        status: item.status,
                        companyWE: companyA,
                        companySN: companyB               
                    })
                }
            });
            return result
        },
        getTitle(){
            let params = {
                opcode: this.$code.PublishQuery,
                i_serial_mark: this.pubId,
                c_status: '',
                v_type: '',
                v_theme: '',
                start_date: '',
                end_date: '',
                pagesize: 10,
                page: 1,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    let list = result.map(item=>{                        
                        return{
                            title: item['主题'],
                            round: item['比赛轮数']+1,
                            maxRound: item['轮数'],
                        }
                    })
                    this.titlePub = list[0].title 
                    this.round = list[0].round <= list[0].maxRound ? list[0].round : list[0].maxRound
                    setTimeout(()=>{
                        this.initData()
                    })
                }
            })
        },
        toggleFullScreen(){
            if (!document.fullscreenElement) {
                this.$help.enterFullScreen();
            } else {
                this.$help.exitFullScreen();
            }
        }, 
    },
    beforeDestroy() {
        // 在实例销毁前移除事件监听
        document.removeEventListener('click', this.toggleFullScreen);
    },
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.content{
    width: 100%;
    overflow: auto;
}
.title{
    font-size: 28px;
    padding: 8px 0;
    text-align: center;
    color: gold;
    background-color: #de2c11;
}
.round-title{
    font-size: 24px;
    text-align: center;
    margin-top: 4px;
}
.matches-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
    gap: 20px;
    margin-bottom: 30px;
}

.match-card {
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
    transition: transform 0.3s, box-shadow 0.3s;
}

.match-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.table-number {
    text-align: center;
    font-weight: bold;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 2px solid #eee;
    color: #1a6bc4;
    background-color: #f8f9fa;
    padding: 12px;
    border-radius: 8px;
    font-size: 18px;
}

.team {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 12px 0;
    padding: 12px;
    border-radius: 8px;
}

.team-east {
    background-color: #e8f4fd;
    border-left: 5px solid #1a6bc4;
}

.team-south {
    background-color: #fff8e1;
    border-left: 5px solid #ffa000;
}

.team-position {
    font-weight: bold;
    color: #555;
    min-width: 70px;
    font-size: 16px;
}

.team-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-grow: 1;
    text-align: center;
}

.team-code {
    font-weight: bold;
    color: #1a6bc4;
    font-size: 18px;
    margin-bottom: 5px;
}

.team-name {
    font-size: 18px;
    color: #666;
}

.team-role {
    font-size: 16px;
    color: #ec0303;
    // min-width: 50px;
    text-align: right;
    background: rgba(0, 0, 0, 0.05);
    padding: 4px 8px;
    border-radius: 4px;
}

.teams-info {
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
}

.teams-title {
    font-weight: bold;
    margin-bottom: 15px;
    color: #1a6bc4;
    border-bottom: 2px solid #eee;
    padding-bottom: 8px;
    font-size: 16px;
}

.teams-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 12px;
}

.team-item {
    padding: 12px;
    background: #f8f9fa;
    border-radius: 8px;
    text-align: center;
    font-weight: bold;
    border-left: 4px solid #1a6bc4;
}

.round-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.action-buttons {
    display: flex;
    gap: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/teamFullScreen/fullArrange.vue